import module from 'colaborador/module.js'
import template from './template.html'

export class ColaboradorIncapacidadesAgregarComponent {
  idProyecto
  idColaborador
  onChange
  onClose
  agregando = false
  respuesta = null
  data = {
    id_proyecto: null,
    id_colaborador: null,
    id_tipo_incapacidad: undefined,
    fecha_inicial: null,
    fecha_final: null,
    folio: '',
    duracion: null,
    notas: '',
    pagos: [],
  }

  constructor (ColaboradorIncapacidades) {
    this.ColaboradorIncapacidades = ColaboradorIncapacidades
  }

  $onInit () {
    this.data.id_proyecto = this.idProyecto
    this.data.id_colaborador = this.idColaborador
  }

  agregar () {
    if (this.agregando) return

    this.agregando = true

    this.ColaboradorIncapacidades.post(this.idProyecto, this.idColaborador, this.data)
      .then(({data}) => {
        this.respuesta = Object.assign({}, this.data, data)
        this.cerrar()
      })
      .finally(() => (this.agregando = false))
  }

  cerrar () {
    this.onClose({$event: {detail: this.respuesta}})
  }
}

module.component('colaboradorIncapacidadesAgregar', {
  controller: ColaboradorIncapacidadesAgregarComponent,
  template,
  bindings: {
    idProyecto: '<',
    idColaborador: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/colaborador/components/incapacidades/agregar/component.js